
import React from 'react';

const GrayPhoneIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    {...props}
  >
    <path
      d="M2.51833 7.46173C1.88632 6.3597 1.58115 5.45982 1.39714 4.54764C1.125 3.19855 1.74779 1.8807 2.77951 1.03981C3.21555 0.684418 3.71541 0.805841 3.97325 1.26843L4.55537 2.31277C5.01678 3.14054 5.24748 3.55442 5.20172 3.99322C5.15596 4.43202 4.84483 4.7894 4.22257 5.50417L2.51833 7.46173ZM2.51833 7.46173C3.79759 9.69234 5.80514 11.701 8.03835 12.9817M8.03835 12.9817C9.14038 13.6138 10.0403 13.9189 10.9524 14.1029C12.3015 14.3751 13.6194 13.7523 14.4603 12.7206C14.8157 12.2845 14.6942 11.7847 14.2317 11.5268L13.1873 10.9447C12.3595 10.4833 11.9457 10.2526 11.5069 10.2984C11.0681 10.3441 10.7107 10.6553 9.99591 11.2775L8.03835 12.9817Z"
      stroke="#002564"
      strokeOpacity="0.5"
      strokeLinejoin="round"
    />
  </svg>
);

export default GrayPhoneIcon;